import React, {useContext} from 'react';
import './LocationList.less';
import {LocationCard} from "compositions/location-card/LocationCard";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {List} from "elements/list/List.tsx";
import {OrderingTypes} from "new-constants/common.constants";
import {getDeliveryTimeString} from "helpers/restaurant.helper";
import {getScheduleString} from "helpers/restaurant.helper";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";


function getDeliveryConditionsString(deliveryMinAmount, deliveryPrice, translations) {
	let priceMessage = typeof deliveryPrice === 'number' && deliveryPrice > 0
		? getSafeTranslation('LocationList.deliveryConditionPriceLabel', translations).replace('{price}', deliveryPrice)
		: '';
	let amountMessage = typeof deliveryMinAmount === 'number' && deliveryMinAmount > 0
		? getSafeTranslation('LocationList.deliveryConditionMinAmountLabel', translations).replace('{minAmount}', deliveryMinAmount)
		: '';

	return `${priceMessage} ${amountMessage}`;
}

export const LocationList = ({locations = [], orderingType, onLocationClick}) => {
	const translations = useContext(TranslationsContext);

	return <List isModal>
		{
			locations.map((location, index) => <ListItem key={location.restaurantId}
																									 onClick={() => onLocationClick(location.restaurantId)}>
					<LocationCard
						name={location.name}
						address={
							orderingType === OrderingTypes.delivery
								? getDeliveryConditionsString(location.deliveryMinAmount, location.deliveryPrice, translations)
								: location.address
						}
						schedule={
							orderingType === OrderingTypes.delivery ?
							getDeliveryTimeString(location, translations) :
							getScheduleString(location.todaySchedule, translations)
						}
						image={location.thumbnail || location.picture}
					/>
				</ListItem>
			)
		}
	</List>
}
